import { Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  tabWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    marginTop: theme.spacing(3),
  },
  iconWrapper: {
    width: '28px',
    height: '28px',
    background: theme.palette.textBackground.main,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: theme.spacing(2),
    height: theme.spacing(2.5),
    weight: 400,
    style: 'Regular',
    fontSize: '16px',
    color: theme.palette.labraText.primary,
    horizontalAlignment: 'center',
    verticalAlign: 'middle',
  },
  heading: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    fontStyle: 'Medium',
    fontSize: '18px',
    leadingTrim: 'NONE',
    lineHeight: '27px',
    letterSpacing: '0%',
  },
  headingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  radioSectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  radioHeading: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    fontStyle: 'Medium',
    fontSize: '14px',
    leadingTrim: 'NONE',
    lineHeight: '20px',
    letterSpacing: '0.1px',
  },
  autoFillOption: {
    paddingLeft: theme.spacing(0.5),
  },
}))
